<template>
    <div
      :class="`dashboard-box elevation-3 ${clickable ? 'cursor-pointer' : ''}`"
      :style="{ backgroundColor: bgColor, gridColumn: `span ${spanColumns}`, gridRow: `span ${spanRows}` }"
      @click="$emit('blur')"
    >
      <span :style="{ fontSize: fontSize, textAlign: textAlign}">{{ title }}</span>
      <span :style="{ color: textColor, fontSize: numberSize, textAlign: textAlign }">
        <strong style="font-weight: 500;">{{ value }}</strong>
      </span>
    </div>
  </template>
  
  <script>
  export default {
    name: "SGPGridBoxComponent",
    props: {
      title: { type: String, required: true },
      value: { type: String, required: true },
      bgColor: { type: String, default: '#ffffff' },
      fontSize: { type: String, default: '12px' },
      numberSize: { type: String, default: '12px' },
      textColor : { type: String, default: '#000000' },
      spanColumns: { type: Number, default: 1 },
      spanRows: { type: Number, default: 1 },
      clickable: { type: Boolean, default: false },
      lineHeight: { type: String, default: '52px', required: false },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .dashboard-box {
    padding: 20px;
    /* border: 1px solid #ddd; */
    text-align: center;
    border-radius: 8px;
    justify-content: center; 
    align-items: center; 
    display: flex; /* Use Flexbox */
    flex-direction: column;
  }
  
  .dashboard-box h3 {
    font-size: 1.2em;
    margin: 0;
    text-align: center;
    justify-content: center;
    align-items: center; 
  }
  
  .dashboard-box p {
    font-size: 1.5em;
    margin: 10px 0 0;
    text-align: center;
    justify-content: center;
    align-items: center; 

  }
  </style>
  